import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["SignOutButton"] */ "/opt/render/project/src/src/components/auth/sign-out-button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/src/components/header/header-actions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Posthog"] */ "/opt/render/project/src/src/components/posthog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromoCodeBanner"] */ "/opt/render/project/src/src/components/promo-code-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StartQuizHandler"] */ "/opt/render/project/src/src/components/quiz/start-quiz-handler.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/src/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PriceCallout"] */ "/opt/render/project/src/src/page-components/landing-page/price-callout.tsx");
